import React from 'react';
import { useAppContext } from 'src/components/app-context';
import { ColorVariantsGrid } from './color-variants-grid';
import { IVariantsProps } from '../types';

export const ColorVariantsMobileVersion: React.FC<IVariantsProps> = props => {
  const { variants, handleSelection } = props;
  const { t } = useAppContext();

  return (
    <ColorVariantsGrid
      variants={variants}
      handleSelection={handleSelection}
      title={t('product', 'label.color')}
    />
  );
};
